const brands = [
  'highline wellness',
] as const


export default {
  brands,
} as const
